module.exports = __webpack_public_path__ + "img/viewPointMapIcon_selecting.92d4c95c.png";